import { ClockCircleOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import styles from './RelativeTime.module.scss';

dayjs.extend(relativeTime);

export const RelativeTime = ({ date }: { date: string | Date }) => (
  <Flex align="center" gap={4} className={styles.time}>
    <ClockCircleOutlined />
    <Typography.Text type="secondary" className={styles.text}>
      {dayjs(date).fromNow()}
    </Typography.Text>
  </Flex>
);
